<!-- 首页 -->
<template>
<div>
  <zd-home v-if="userInfo.AUTH_PAGE==1" ref="zdHome"></zd-home>
  <!-- <xfjd ref="xfjd" v-else></xfjd> -->
  <!-- <contractMasterManySlave></contractMasterManySlave> -->
  <!-- <h1 style="text-align: center;">欢迎登录浩宇南天医药信息平台</h1> -->
</div>
</template>

<script>
import contractMasterManySlave from '../business/cbs/contractMasterManySlave'
import Xfjd from './XFJD'
import ZdHome from './ZdHome'
import {mapGetters} from 'vuex'
import { post } from "@/api/table/table";
export default {
  components: {
    Xfjd,
    ZdHome,
    contractMasterManySlave,
  },
  data() {
    return {
      firstEnter:true,
      moduleId:"300",
      existence:false,
      jyjgexis:false,
      cpwsjtj:false,
      cpjdList:[],
      dwtjObj:{}
    };
  },
  computed: {
    ...mapGetters(['userInfo',"setIp"]),
    //河南Api
    isHNApi() {
      // return this.userInfo.db_id == '41' || this.userInfo.appserver_id == '41' || process.env.NODE_ENV === 'development'
      return this.userInfo.db_id == '41' || this.userInfo.appserver_id == '41'
      // return false
    }
  },
  watch: {
    $route(to,from){
      if(to.path=="/wel/index"){
        this.moduleId=to.query.MODULE_ID||300;
        if(this.moduleId==306){
          this.getData();
        }
        // 滚动条置顶
        if(document.getElementById('avue-view')){
          document.getElementById('avue-view').scrollTop = 0;
        }
      }
    }
  },
  //方法集合
  methods: {
    //河南-个性化-数据映射检查提示
    checkDataMap(){
      //限制级别 总、支、大  ['1','2','3','4'] this.userInfo.user_level
      //限制管理员 总、支、大 ['1','2','3','4'] this.userInfo.      限制总、支、大 ['1','2','3','4'] this.userInfo.role_id

      if(this.isHNApi) {
          post( "/api/blade-xfjd/api/gxh/unmappedUnits", this.$qs.stringify({ runId: this.userInfo.runId }) )
          .then(res=>{
            let data = res.data.data || []
            console.log(data.length,'data.length')
            if(data.length) {
              this.$notify.info({
                title: '消息',
                message: '存在市场监督管理所没有映射消防救援机构，请在个性化->市场监管单位映射界面 中配置映射关系。'
              });
            }
            console.log(res)
          })
          .catch(err => {})
      }
    },
    // 获取数据
    getData(first){
      post(
        "/api/blade-xfjd/api/xfcp/getcpsysj",
        this.$qs.stringify({ runId: this.userInfo.runId })
      ).then(res=>{
        this.cpjdList = res
        let result = res.data.data[0]
        let cresult = {...result,SFJYJG:0,SFPDZX:0}
        let arr = Object.values(cresult)
        let sum = arr.reduce((pre,next)=>{
          return +next+pre
        },0)
        if(sum>0){
          // if(result.SFPDZX==1) return false
          //大于零 显示
          result.SFJYJG==1 ? this.jyjgexis = true :this.existence = true;
          if(result.SFJYJG==1) this.moduleId=306;
          this.cpwsjtj = false;
        }else{
          this.moduleId=306;
          this.getcpDwData();
        }
      })
    },
    // 没有任务的时候展示的首页
    async getcpDwData(zgdwid){
      let res = await post("/api/blade-xfjd/api/xfcp/getCpsysjDw",this.$qs.stringify({ runId: this.userInfo.runId, zgdwid: zgdwid || this.userInfo.company_id}))
      console.log(res);
      this.dwtjObj = res.data.data;
      this.cpwsjtj = true;
    },
    // 产品首页选择单位重新调取接口
    async dwSelect(param){
      await this.getcpDwData(param);
      await this.$refs.dw306.initData();
    },
    // 刷新数据
    onLoad(){
      try {
        if(this.$refs[`home${this.moduleId}`]) {
          if(this.moduleId == 300) {
            this.$refs[`home${this.moduleId}`].onLoadNeed('refresh');
          }else {
            this.$refs[`home${this.moduleId}`].onLoad();
          }
        }else {
          this.$refs[`xfjd`].onLoadNeed('refresh');
        }
      } catch (error) {
        this.$refs.xfjd&&this.$refs.xfjd.onLoad();
      }
    },
  },
  created() {
    this.moduleId=this.$route.query.MODULE_ID||"300";
    if(this.moduleId==306){
      this.getData();
    }
  },
  mounted() {},
  activated() {
    console.log("index");
    if(this.firstEnter){
      //河南-市场监督管理局采集数据映射
    this.checkDataMap()
      this.firstEnter=false;
    }else{
      this.onLoad();
    }

  },
};
</script>
<style lang='scss' scoped>
</style>
